import React from "react"

// import Swiper core and required modules
import { Navigation, Pagination, Autoplay, Lazy } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"

// Import Swiper styles
import "swiper/css"
import "swiper/css/bundle"
import { RenderRichContent } from "../RenderRichContent/RenderRichContent"
import * as styles from "./CustomerSlider.module.scss"
import "./CustomerSlider.css"

const CustomerSlider = ({ data, hideImpact }) => {
  return (
    <div
      className={`max-w-[1268px] mx-auto mt-20 mb-16 p-2 ${styles.wrapper} relative reference`}
    >
      <div className="flex items-center px-[40px] mx-auto justify-between mb-6">
        <div className={`${styles.sliderHeader}`}>
          {!hideImpact && (
            <ul className="ml-0">
              <li>Impact</li>
            </ul>
          )}
          <RenderRichContent content={data.sliderIntro} />
        </div>
        <div className="flex items-center gap-[1.5rem] navigation-buttons">
          <div className="swiper-button-prev custom-prev"></div>
          <div className="swiper-button-next custom-next"></div>
        </div>
      </div>
      <Swiper
        modules={[Navigation, Pagination, Autoplay, Lazy]}
        navigation={{
          prevEl: ".custom-prev",
          nextEl: ".custom-next",
        }}
        loop
        pagination={false}
        lazy={{
          enabled: true,
          checkInView: false,
        }}
        autoplay={{
          delay: 5000,
        }}
        slidesPerView={1}
        breakpoints={{
          1024: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
        }}
      >
        {data?.sliderItems?.map((testimonial, index) => (
          <SwiperSlide key={index} className={styles.block}>
            <div className={`bg-[#f2f5f9] rounded-[40px] p-6 ${styles.sliderwidth}`}>
              <div className={styles.testimonialBlock}>
                <RenderRichContent content={testimonial.text} />
                <img 
                  src={testimonial.image.file.url} 
                  alt={testimonial.image.description || "Customer testimonial"}
                  className=""
                />
              </div>
              <hr />
              <div className={`lg:flex justify-between ${styles.author}`}>
                <RenderRichContent content={testimonial.usp1} />
                <RenderRichContent content={testimonial.usp2} />
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default CustomerSlider